import { RESEND_TIMER_SECONDS_IN_MINUTE } from './useResendTimer.constants'

function toTimerPart(value) {
  return String(value).padStart(2, '0')
}

export function formatResendTimerSeconds(seconds) {
  return `${toTimerPart(Math.floor(seconds / RESEND_TIMER_SECONDS_IN_MINUTE))}:${toTimerPart(seconds % RESEND_TIMER_SECONDS_IN_MINUTE)}`
}
